import { Routes } from "@angular/router";
import { roleGuard } from "@kno2/core/session";
import { routes as organizationRoutes } from "./organizations/admin-organizations.routes";

export const routes: Routes = [
    {
        path: "admin",
        canActivateChild: [roleGuard],
        children: [
            ...organizationRoutes,
            {
                path: "messages",
                loadComponent: () => import("./messages/admin-messages.component").then((c) => c.AdminMessagesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "utils",
                loadComponent: () => import("./utils/admin-utils.component").then((c) => c.AdminUtilsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "workflows",
                loadComponent: () => import("./bulk-workflow-retry/admin-bulk-workflow-retry.component").then((c) => c.AdminBulkWorkflowRetryComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "securelogs",
                loadComponent: () => import("./secure-logs/admin-secure-logs.component").then((c) => c.AdminSecureLogsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "reports",
                loadComponent: () => import("./reports/admin-reports.component").then((c) => c.AdminReportsComponent),
                data: {
                    roles: ["SysAdmin", "SysAdminReporting"]
                }
            },
            {
                path: "apicapture",
                loadComponent: () => import("./api-capture/admin-api-capture.component").then((c) => c.AdminApiCaptureComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "subscriptionplans",
                loadComponent: () => import("./subscription-plans/admin-subscription-plans.component").then((c) => c.AdminSubscriptionPlansComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "reservedwords",
                loadComponent: () => import("./reserved-words/reserved-words.component").then((c) => c.ReservedWordsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "healthserviceareas",
                loadComponent: () => import("./health-service-areas/admin-health-service-areas.component").then((c) => c.AdminHealthServiceAreasComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "healthreferralregions",
                loadComponent: () =>
                    import("./health-referral-regions/admin-health-referral-regions.component").then((c) => c.AdminHealthReferralRegionsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "featureToggle",
                loadComponent: () => import("./feature-toggle/admin-feature-toggle.component").then((c) => c.AdminFeatureToggleComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "downloads",
                loadComponent: () => import("./downloads/admin-downloads.component").then((c) => c.AdminDownloadsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "serviceaccounts",
                loadComponent: () => import("./service-accounts/service-accounts.component").then((c) => c.ServiceAccountsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "serviceaccounts/:clientId",
                loadComponent: () => import("./service-accounts/service-accounts-edit.component").then((c) => c.ServiceAccountsEditComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "audits",
                loadComponent: () => import("./audits/admin-audits.component").then((c) => c.AdminAuditsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "clientapplications",
                loadComponent: () => import("./client-applications/admin-client-applications.component").then((c) => c.AdminClientApplicationsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "clientapplications/:clientId",
                loadComponent: () => import("./client-applications/admin-client-applications.component").then((c) => c.AdminClientApplicationsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "certificates",
                loadComponent: () => import("./certificates/admin-certificates.component").then((c) => c.AdminCertificatesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "batchimports",
                loadComponent: () => import("./batch-imports/admin-batch-imports.component").then((c) => c.AdminBatchImportsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "documenttypes",
                loadComponent: () => import("../settings/document-types/document-types.component").then((c) => c.DocumentTypesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "releasetypes",
                loadComponent: () => import("../settings/release-types/release-types.component").then((c) => c.ReleaseTypesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "directorydownloads",
                loadComponent: () => import("./directory-downloads/admin-directory-downloads.component").then((c) => c.AdminDirectoryDownloadsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "documentsources",
                loadComponent: () => import("./document-sources/admin-document-sources.component").then((c) => c.AdminDocumentSourcesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "fax",
                loadComponent: () => import("./document-sources/admin-document-sources.component").then((c) => c.AdminDocumentSourcesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "connectors",
                loadComponent: () => import("./connectors/admin-connectors.component").then((c) => c.AdminConnectorsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "licensetypes",
                loadComponent: () => import("./license-types/admin-license-types.component").then((c) => c.AdminLicenseTypesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "licensekeys",
                loadComponent: () => import("./license-keys/admin-license-keys.component").then((c) => c.AdminLicenseKeysComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "integrations",
                pathMatch: "full",
                loadComponent: () => import("./integrations/admin-integrations.component").then((c) => c.AdminIntegrationsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "integrations/whitelist",
                pathMatch: "full",
                loadComponent: () =>
                    import("./integrations/whitelist/admin-integrations-whitelist.component").then((c) => c.AdminIntegrationsWhitelistComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "integrations/:integrationName",
                loadComponent: () => import("./integrations/admin-integrations-organizations.component").then((c) => c.AdminIntegrationsOrganizationsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "resellers",
                loadComponent: () => import("./resellers/admin-resellers.component").then((c) => c.AdminResellersComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "partners",
                loadComponent: () => import("./partners/admin-partners.component").then((c) => c.AdminPartnersComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "brands",
                loadComponent: () => import("./brands/admin-brands.component").then((c) => c.AdminBrandsComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "brands/:id/:name",
                loadComponent: () => import("./brands/admin-brands-edit.component").then((c) => c.AdminBrandsEditComponent),
                data: {
                    roles: ["SysAdmin"]
                },
                children: [
                    {
                        path: "",
                        redirectTo: "details",
                        pathMatch: "full"
                    },
                    {
                        path: "details",
                        loadComponent: () => import("./brands/details/admin-brands-details.component").then((c) => c.AdminBrandsDetailsComponent)
                    },
                    {
                        path: "privatelabel",
                        loadComponent: () =>
                            import("./brands/private-label/admin-brands-private-label.component").then((c) => c.AdminBrandsPrivateLabelComponent)
                    },
                    {
                        path: "settings",
                        loadComponent: () => import("./brands/settings/admin-brands-settings.component").then((c) => c.AdminBrandsSettingsComponent)
                    },
                    {
                        path: "externalserviceaccounts",
                        loadComponent: () =>
                            import("./brands/service-accounts/admin-brands-service-accounts.component").then((c) => c.AdminBrandsServiceAccountsComponent)
                    }
                ]
            },
            {
                path: "networks",
                loadComponent: () => import("./networks/admin-networks.component").then((c) => c.AdminNetworksComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "users",
                loadComponent: () => import("./users/admin-users.component").then((c) => c.AdminUsersComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "users/deprovision",
                loadComponent: () => import("./user-deprovisioning/admin-user-deprovisioning.component").then((c) => c.AdminUserDeprovisioningComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "organizationTypes",
                loadComponent: () => import("./organization-types/admin-organization-types.component").then((c) => c.AdminOrganizationTypesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "organizationSpecialties",
                loadComponent: () =>
                    import("./organization-specialties/admin-organization-specialties.component").then((c) => c.AdminOrganizationSpecialtiesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "directory",
                loadComponent: () => import("./directory/admin-directory.component").then((c) => c.AdminDirectoryComponent),
                data: {
                    roles: ["SysAdmin", "Administrator"]
                }
            },
            {
                path: "eulas",
                loadComponent: () => import("./eulas/admin-eulas.component").then((c) => c.AdminEulasComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            },
            {
                path: "messageroutingrules",
                loadComponent: () => import("./routing-rules/admin-routing-rules.component").then((c) => c.AdminRoutingRulesComponent),
                data: {
                    roles: ["SysAdmin"]
                }
            }
        ]
    }
];
